const styles = () => ({
  filterMenu: {
    marginTop: '1px',
  },
});

export default styles;